(() => {
  if (window.sosGearLogoUploadsReady) return;
  window.sosGearLogoUploadsReady = true;
  const selector = '[data-gear-logo-file]';
  const variantSelector = '.variant-input-wrap select, .variant-input-wrap input[type="radio"]:checked';
  const syncGroup = group => {
    const form = group.closest('form');
    const pantsOnly = Array.from(form.querySelectorAll(variantSelector))
      .some(input => input.value.toLowerCase().trim() === 'pants');
    group.hidden = pantsOnly;
    group.querySelectorAll('input, textarea').forEach(input => {
      input.disabled = pantsOnly;
    });
    return !pantsOnly;
  };
  const syncGroups = root => root.querySelectorAll('[data-gear-logos]').forEach(syncGroup);
  syncGroups(document);
  document.addEventListener('shopify:section:load', event => syncGroups(event.target));
  document.addEventListener('sos:product-form:ready', event => syncGroups(event.target));
  document.addEventListener('change', event => {
    if (!event.target.matches('.variant-input-wrap select, .variant-input-wrap input[type="radio"]')) return;
    const form = event.target.closest('form');
    if (form) syncGroups(form);
  });
  const validate = input => {
    const file = input.files[0];
    const group = input.closest('[data-gear-logos]');
    const valid = !file || (/\.(png|jpe?g|webp|svg|pdf|ai)$/i.test(file.name) && file.size > 0 && file.size <= 10 * 1024 * 1024);
    input.setCustomValidity(valid ? '' : group.dataset.fileError);
    return valid;
  };
  document.addEventListener('change', event => {
    if (!event.target.matches(selector)) return;
    if (!validate(event.target)) {
      event.target.closest('details').open = true;
      event.target.reportValidity();
    }
  });
  document.addEventListener('invalid', event => {
    if (event.target.matches(selector)) event.target.closest('details').open = true;
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const group = form.querySelector('[data-gear-logos]');
    if (!group || !syncGroup(group)) return;
    const inputs = Array.from(group.querySelectorAll(selector));
    const invalid = inputs.find(input => !validate(input));
    if (invalid) {
      event.preventDefault();
      event.stopImmediatePropagation();
      group.open = true;
      invalid.focus();
      invalid.reportValidity();
      return;
    }
    if (!inputs.some(input => input.files.length)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.gearUploading || !form.reportValidity()) return;
    form.dataset.gearUploading = 'true';
    form.method = 'post';
    form.enctype = 'multipart/form-data';
    for (const input of inputs) {
      if (!input.files.length) input.disabled = true;
    }
    let destination = form.querySelector('input[name="return_to"]');
    if (!destination) {
      destination = document.createElement('input');
      destination.type = 'hidden';
      destination.name = 'return_to';
      form.append(destination);
    }
    destination.value = group.dataset.cartUrl;
    group.open = true;
    group.querySelector('[data-gear-upload-status]').hidden = false;
    form.querySelectorAll('[type="submit"]').forEach(button => button.setAttribute('aria-busy', 'true'));
    HTMLFormElement.prototype.submit.call(form);
  }, true);
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('form[data-gear-uploading]').forEach(form => {
      delete form.dataset.gearUploading;
      syncGroups(form);
      form.querySelector('[data-gear-upload-status]').hidden = true;
      form.querySelectorAll('[type="submit"]').forEach(button => button.removeAttribute('aria-busy'));
    });
    syncGroups(document);
  });
})();

